import React, { useState, useEffect } from 'react';
import CISbohol from '../Admin/cisBohol'; 
import CISsiquijor from '../Admin/cisSiquijor';
import CISNOSO from '../Admin/cisNOSO';
import styled from 'styled-components';
import CISboholImport from '../Admin/cisBoholimport';

const CIS = ({ darkMode, onSelect, isSidebarExpanded = false }) => {
  const CIS_MACHINERIES_RETURN_KEY = 'cisMachineriesReturn';
  const [selectedPage, setSelectedPage] = useState('CISBohol');
  const [showFooter, setShowFooter] = useState(true);
  const [showImport, setShowImport] = useState(false); // controls import component visibility

  // Reset to 'CISBohol' when component mounts
  useEffect(() => {
    setSelectedPage('CISBohol');
  }, []);

  useEffect(() => {
    const pending = localStorage.getItem(CIS_MACHINERIES_RETURN_KEY);
    if (!pending) return;

    try {
      const parsed = JSON.parse(pending);
      if (parsed?.sectionKey === 'CISsiquijor') {
        setSelectedPage('CISsiquijor');
      } else if (parsed?.sectionKey === 'CISNOSO') {
        setSelectedPage('CISNOSO');
      } else {
        setSelectedPage('CISBohol');
      }
    } catch (err) {
      setSelectedPage('CISBohol');
    }
  }, []);

  const renderPage = () => {
  switch (selectedPage) {
    case 'CISsiquijor':
      return <CISsiquijor darkMode={darkMode} onSelect={onSelect} isSidebarExpanded={isSidebarExpanded} />;
    case 'CISNOSO':
      return <CISNOSO darkMode={darkMode} onSelect={onSelect} isSidebarExpanded={isSidebarExpanded} />;
    case 'CISBohol':
    default:
      return (
        <CISbohol
          darkMode={darkMode}
          onSelect={onSelect}
          isSidebarExpanded={isSidebarExpanded}
          setShowFooter={setShowFooter}
          openImport={() => setShowImport(true)}
        />
      );
  }
};

  return (
  <Container darkMode={darkMode}>
    <ContentWrapper>
      {showImport ? (
        <CISboholImport
          darkMode={darkMode}
          isSidebarExpanded={isSidebarExpanded}
          onClose={() => setShowImport(false)} 
          onSave={() => setShowImport(false)}  
          selectedYear={2025}
          setSelectedYear={() => {}}
          importedFile={null}
          setShowFooter={setShowFooter}
        />
      ) : (
        renderPage()
      )}
    </ContentWrapper>
    {showFooter && !showImport && (
      <FooterWrapper>
        <FooterButton onClick={() => setSelectedPage('CISBohol')}>Bohol</FooterButton>
        <FooterButton onClick={() => setSelectedPage('CISsiquijor')}>Siquijor</FooterButton>
        <FooterButton onClick={() => setSelectedPage('CISNOSO')}>NOSO</FooterButton>
      </FooterWrapper>
    )}
  </Container>
);
}

export default CIS;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const ContentWrapper = styled.div`
  flex: 1;
`;

const FooterWrapper = styled.div`
  background: ${({ darkMode }) => (darkMode ? '#222' : '#eee')};
  padding: 10px;
  display: flex;
  justify-content: left;
  gap: 20px;
  position: sticky;
  bottom: 0;
  z-index: 100;
`;

const FooterButton = styled.button`
  margin: 0 2px;
  padding: 6px 10px;
  background-color: #eee;
  border: 1px solid #aaa;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;

  &:hover {
    background-color: #ddd;
  }
`;
